import styled, { css } from 'styled-components';
import { breakpoint } from '../../theme/breakpoint';
import generateQS from '../../styled/background-image';
import RichText from '../../rich-text';
import { h4 } from '../../styled/typography';

const mobileHeight = '162px';
const tabletHeight = '285px';
const desktopHeight = '227px';
const desktopSidebarHeight = '173px';

const imageSizes = {
  mobile: [288, 162],
  tablet: [304, 285],
  desktop: [480, 227],
  desktopSidebar: [309, 173],
};

export const ModuleWrapper = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.xlarge};
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.tablet`
    flex-basis: 50%;
  `};

  min-height: ${mobileHeight};
  ${breakpoint.tablet` min-height: ${tabletHeight};`};
  ${breakpoint.desktop` min-height: ${({ $sidebar }) =>
    $sidebar ? desktopSidebarHeight : desktopHeight};`};
`;

export const Image = styled.div`
  flex: 1 0 auto;
  background-size: cover;
  background-color: ${({ theme }) => theme.palette.lightBackground};
  background-position: ${({ $alignImage }) => `${$alignImage}`};

  background-image: ${({ $image: image, $alignImage: alignImage }) =>
    image && generateQS({ image, alignImage, imageSizes, size: 'mobile' })};

  ${breakpoint.tablet`
    flex-grow: 1;
    flex-basis: 50%;
    background-image: ${({ $image: image, $alignImage: alignImage }) =>
      image && generateQS({ image, alignImage, imageSizes, size: 'tablet' })};
  `};

  ${breakpoint.desktop`
    background-image: ${({
      $image: image,
      $alignImage: alignImage,
      $sidebar,
    }) =>
      image &&
      generateQS({
        image,
        alignImage,
        imageSizes,
        size: $sidebar ? 'desktopSidebar' : 'desktop',
      })};
  `}
`;

export const TextWrapper = styled.div`
  position: relative;
  padding-top: ${({ theme }) => theme.spacing.standard};

  ${breakpoint.tablet`
    padding-top: ${({ theme }) => theme.spacing.large};
    flex-grow: 1;
    flex-basis: 50%;
  `};
`;

export const StyledRichText = styled(RichText)`
  // override all content to become an H4
  p,
  h3 {
    ${h4};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Title = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
`;

export const BrushElement = styled.img`
  width: 64px;
  height: 46px;
  margin-top: -${({ theme }) => theme.spacing.xlarge};

  ${breakpoint.tablet`
    margin-top: 0;
    position: unset;
  `};
`;

export const Author = styled.div`
  margin-top: ${({ theme }) => theme.spacing.standard};
  color: ${({ theme }) => theme.palette.secondaryText};
  font-style: italic;
`;

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  flex-direction: column;
  display: flex;

  ${breakpoint.tablet`
    flex-direction: ${({ $sidebar }) => ($sidebar ? 'row' : 'column')};
    margin-bottom: 0;
  `};

  ${breakpoint.desktop`
    flex-direction: ${({ $sidebar }) => ($sidebar ? 'column' : 'row')};
  `};

  ${({ $isSlider, $isOdd, $sidebar, theme }) =>
    !$isSlider
      ? /* Single / List Layout */
        css`
          ${!$sidebar
            ? /* single / list layout - non sidebar */
              css`
                ${breakpoint.tablet`
                  flex-direction: ${$isOdd ? 'row-reverse' : 'row'};
                `};

                ${TextWrapper} {
                  // left/right padding for l/r alternating text layout on multi list
                  ${breakpoint.tablet`
                    padding: ${theme.spacing.standard};
                    padding-left: ${$isOdd && 0};
                    padding-right: ${!$isOdd && 0};
                  `}
                }

                ${BrushElement} {
                  margin-left: ${theme.spacing.tiny};

                  ${breakpoint.tablet`
                    margin-left: 0;
                  `};
                }
              `
            : /* single / list layout - is sidebar */
              css`
                flex-direction: column;

                ${TextWrapper} {
                  padding: 0;
                }

                // non slider sidebar overrides for brush element
                ${BrushElement} {
                  margin-top: ${`-${theme.spacing.medium}`};
                  margin-left: ${theme.spacing.tiny};
                }
              `}
        `
      : /* Slider Layout */
        css`
          ${TextWrapper} {
            padding: ${theme.spacing.standard};
            border-width: 1px;
            border-color: ${theme.palette.border};
            border-style: none solid solid solid;
            flex-grow: 1;

            ${breakpoint.desktop`
              border-style: solid solid solid none;
            `};
          }

          ${$sidebar &&
          css`
            ${TextWrapper} {
              border-style: none solid solid solid;
            }

            ${ImageWrapper} {
              ${breakpoint.desktop`
                flex-basis: auto;
              `};
            }

            // sidebar overrides for slider brush element
            ${BrushElement} {
              ${breakpoint.desktop`
              margin-top: -40px;
              `}
            }
          `}
        `}
`;
